import { isInlineQuiz } from "./getContainerID"

const inlineQuiz = isInlineQuiz();

export const handleQuizInitialized = (index: number, quizLength: number, prevQid: string, presentQid: string) => {
    const detail = `${index}_${quizLength}_${prevQid}_${presentQid}`
    const eventName = inlineQuiz ? "quiz_initialized" : "popup_quiz_initialized"
    customEventHandler(eventName, detail)
}

export const handleQuizProgress = (index: number, quizLength: number, prevQid: string, presentQid: string) => {
    const detail = `${index}_${quizLength}_${prevQid}_${presentQid}`
    const eventName = inlineQuiz ? "quiz_progress" : "popup_quiz_progress"
    customEventHandler(eventName, detail)
}

export const handleQuizLoad = (quizLoad: string) => {
    const eventName = inlineQuiz ? "react_quiz_loaded" : "popup_quiz_loaded"
    customEventHandler(eventName, quizLoad)
}

export const handleQuizSubmit = (respId: string) => {
    const detail = `${respId}`
    const eventName = inlineQuiz ? "quiz_submit" : "popup_quiz_submit"
    customEventHandler(eventName, detail)
}


const customEventHandler = (eventName: string, detail: string) => {
    const customEvent = new CustomEvent(eventName, { detail })
    window.dispatchEvent(customEvent)
}